export const cursorWrapper = (text: string, size: string, icon: string) =>
  ({
    localCursorOptions: {
      text: text,
      size: size,
      isActive: false,
      isClicked: false,
      icon: icon,
    },
    isScrolling: false,

    onMouseEnter() {
      this.localCursorOptions = {
        ...this.localCursorOptions,
        text: text,
        size: size,
        isActive: true,
      }

      this.$dispatch('cursor:options', this.localCursorOptions)
    },

    onMouseLeave() {
      this.localCursorOptions = {
        ...this.localCursorOptions,
        isActive: false,
      }

      this.$dispatch('cursor:options', this.localCursorOptions)
    },

    onMouseClickToggle(state: boolean) {
      this.localCursorOptions = {
        ...this.localCursorOptions,
        isClicked: state,
      }
      this.$dispatch('cursor:options', this.localCursorOptions)
    },
  }) as any
